import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import React from "react";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#1d1d1f",
        py: 2,
        px: { xs: 2, md: 4 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
            <img
              src={process.env.PUBLIC_URL + "/myslides-logo-white.svg"}
              alt="MySlides"
              height={22}
            />
            <Typography
              sx={{
                color: "#ffffff",
                fontSize: "0.9rem",
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 600,
              }}
            >
              MySlides
            </Typography>
          </Box>
          <Box
            sx={{
              width: "1px",
              height: 14,
              backgroundColor: "#444",
            }}
          />
          <Typography
            sx={{
              color: "rgb(221, 221, 221)",
              fontSize: "0.75rem",
              fontFamily: "'Poppins', sans-serif",
              fontWeight: 500,
            }}
          >
            A product by{" "}
            <a
              href="https://www.medprimetech.com/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "rgb(255, 255, 255)", textDecoration: "none", fontWeight: 500, fontSize: "0.85rem" }}
            >
              medprime
            </a>
          </Typography>
        </Box>
        <Typography
          sx={{
            color: "rgb(221, 221, 221)",
            fontSize: "0.8rem",
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 500,
          }}
        >
          © {new Date().getFullYear()} Medprime Technologies Pvt. Ltd. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
